import {
  FormattedDate,
  parseDate,
  toPrimitiveDateInput,
} from '@superdispatch/dates';
import { TextBox } from '@superdispatch/ui-lab';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { AvailableDateIcon } from 'shared/icons/AvailableDateIcon';
import { PostingLoadDTO } from '../../data/dto/PostingLoadDTO';
import { PostingDescription } from './PostingDescription';

export function PostingAvailableNow() {
  return (
    <PostingDescription
      label="Available"
      icon={<AvailableDateIcon color="action" fontSize="small" />}
    >
      <TextBox variant="body-semibold">Now</TextBox>
    </PostingDescription>
  );
}

export function PostingAvailableDate({
  pickup: { scheduled_at: dateProp, date_type: dateType },
}: PostingLoadDTO) {
  const primitiveInput = toPrimitiveDateInput(dateProp);
  const date = useMemo(() => parseDate(primitiveInput), [primitiveInput]);
  const endOfDay = useMemo(() => DateTime.local().endOf('day'), []);

  const icon = <AvailableDateIcon color="action" fontSize="small" />;

  if (!date.isValid) {
    return (
      <PostingDescription label="Available" icon={icon}>
        <TextBox variant="body-semibold">No Date</TextBox>
      </PostingDescription>
    );
  }

  if (date <= endOfDay) return <PostingAvailableNow />;

  return (
    <PostingDescription
      icon={icon}
      label={dateType === 'not_later_than' ? 'Available until' : 'Available on'}
    >
      <TextBox variant="body-semibold">
        <FormattedDate date={date} variant="Date" />
      </TextBox>
    </PostingDescription>
  );
}
